export const LeaveSettingEN = {
    "leave-setting": {
        "headingLabel": "Leave Setting",
        "createNew": "Create New Leave Setting",
        "generalSetting": "General Settings",
        "senioritySetting": "Seniority Settings",
        "otherSetting": "Other Settings",
        "leaveSettingName": "Leave Setting Name",
        "positionApllication": "Position Apllication",
        "numberOfLeaveDay": "Number Of Leave Day",
        "leaveSettingNameDetails": "Leave setting name will apply to both seniority permission setting and other setting",
        "timeApplication": "Time Application",
        "timeApplicationDetails1": "The settings below will apply only for the time being.",
        "timeApplicationDetails2": "When there is a change in permission rules, you can add new settings and choose the time to apply again.",
        "timeApplicationDetails3": "If the end month is blank, the current month's allowance will be calculated according to this setting.",
        "fromMonth": "Start Month",
        "toMonth": "End Month",
        "applicableObject": "Applicable Object",
        "conditionsApply": "Conditions Apply",
        "advanceLeave": "Advance Leave",
        "dayEndCumulative": "Day End Cumulative",
        "monthEndCumulative": "Month End Cumulative",
        "dayWorkOnLeave": "Day Work On Leave",
        "generalInformation": "General Information",
        "departmentApplication": "Department Application",
        "departmentApplicationDetails1": "The permission policy will apply to the entire department (in this case, leave it blank).",
        "departmentApplicationDetails2": "However, each business will have different regulations (Select multiple departments)",
        "chooseDepartment": "Choose Department Application",
        "positionApplication": "Position Application",
        "positionApplicationDetails1": "The permission rule will apply to the entire position (in this case, leave it blank).",
        "positionApplicationDetails2": "However, each business will have different regulations (Choose many positions)",
        "choosePosition": "Choose Position",
        "chooseContractType": "Choose Contract Type",
        "choosedayStartContractType": "Choose day start contract type",
        "contractType": "Allowed Contract Type",
        "contractTypeDetails1": "As a rule, all employment contracts are allowed.",
        "contractTypeDetails2": "However, you can completely change according to the actual needs of the company.",
        "monthDid": "Number of months of contract performance to be allowed",
        "monthDidDetails": "For example: 1 employee signs a 1-year labor contract, but must work for 2 months or more to be allowed.",
        "dateStartCounted": "The date the calculation is started",
        "dateStartCountedDetails1": "Many companies will allow employees to have a probationary contract as long as the employee is officially contracted.",
        "dateStartCountedDetails2": "This is the step to solve this problem",
        "maximumLeavePerYear": "Maximum number of allow in 1 year",
        "maximumLeavePerYearDetails1": "According to the law, administrative work is 12 days/year.",
        "maximumLeavePerYearDetails2": "However, for heavy work, it can be up to 14, 15 days.",
        "leavePerMonth": "Number of monthly entitlements",
        "totalLeaveDivide12": "Take the total number of spells up to 1 year and divide by 12 months",
        "totalLeaveDivide12Details": "For example: The number of leave in a year of an employee is 15 days, when setting the maximum number of leave divided by 12, each month the employee is entitled to 1.25 days of leave.",
        "1LeavePerMonth": "1 leave per month, the rest is added to the first month",
        "1LeavePerMonthDetails": "If you choose 1 leave per month, the rest is added to the first month, then the first month the employee will be entitled to 4 leave, each following month will be entitled to 1 leave.",
        "cycleCountLeave": "Cycle Count Leave",
        "cycleCountLeaveDetails1": "Often businesses have a calendar year calculation cycle.",
        "cycleCountLeaveDetails2": "However, there are some cases such as school and manufacturing with a non-calendar year calculation cycle.",
        "toEndMonth": "To end of month",
        "dayAddNewLeaveOfMonth": "New allowed day of the month",
        "dayAddNewLeaveOfMonthDetails1": "There are businesses at the beginning of the month that have allowed employees, there are businesses in the middle of the month.",
        "dayAddNewLeaveOfMonthDetails2": "Please choose the right one for your business",
        "firstContractAllowed": "First contract allowed",
        "firstContractAllowedDetails1": "Example: HR Nguyen Van A, whose first contract is allowed has a starting date of March 14, 2016.",
        "firstContractAllowedDetails2": "If the setting is the 16th, then the personnel is authorized for that month.",
        "firstContractAllowedDetails3": "Conversely, if the setting is the 13th, then the personnel is not credited for that month.",
        "accumulationEndTime": "Accumulation end time (reset accumulation to 0)",
        "accumulationEndTimeDetails1": "For example: If the setting is March, then the accumulation and seniority of the previous year to the end of March of this year will be reset to 0.",
        "accumulationEndTimeDetails2": "You can choose to customize the date to select a specific date.",
        "accumulationEndTimeDetails3": "Not selected means the spell will not be accumulated.",
        "employeeLeaveNotAllowed": "Employees who leave work before this day of the month are not allowed that month",
        "employeeLeaveNotAllowedDetails": "Example: If the set date is 15 and you leave on the 14th of the current month, you will not be allowed in this current month.",
        "employeeUnpaidNotAllowed": "Employees who take unpaid leave exceeding this number of days in a month are not entitled to the monthly leave",
        "employeeUnpaidNotAllowedDetails1": "For example: If the setting date is 5 days and you take unpaid leave in that month more than 5 days, then there will be no leave for that month.",
        "employeeUnpaidNotAllowedDetails2": "The number of days of unpaid leave is calculated from the application for leave, for the reason that there is no pay",
        "allowedSeniority": "Allow seniority permission",
        "allowedSeniorityDetails": "Settings that allow long-time employees to enjoy more seniority leave",
        "dayStartCountedSeniority": "The starting date of the seniority calculation",
        "allowedLeave": "Allow to advance leave",
        "allowedLeaveDetails1": "In a year, employees are only allowed to use the number of permits in the year.",
        "allowedLeaveDetails2": "This setting allows employees to take more than their annual leave",
        "allowContractType": "Allowed Contract Type Advance",
        "allowContractTypeDetails1": "Apply permission is a feature that allows businesses to take more leave than they currently have.",
        "allowContractTypeDetails2": "However, this is not true for all contracts (unselected cases are all).",
        "allowContractTypeDetails3": "Please select the type of contract that your business allows",
        "maximumLeaveApplied": "Maximum number of spells applied",
        "maximumLeaveAppliedDetails": "Please select the maximum number of permits employees can apply",
        "monthSeniorytiApllied": "Number of months of seniority eligible to apply for a license",
        "monthSeniorytiAplliedDetails1": "There are employees who sign a 1-year labor contract and that contract is entitled to apply for permission.",
        "monthSeniorytiAplliedDetails2": "However, the company may stipulate that employees must work from the 3rd month to be counted, this step helps you solve that problem.",
        "maternityLeaveNoCounted": "Unauthorized maternity leave settings",
        "materinityCountedAfter": "The day on which the employee takes maternity leave after this date will be counted for that month",
        "materinityCountedBefore": "The date the employee returns from maternity leave before this date will be counted for that month",
        "dayStartWork": "Day start work",
        "dayFirstContract": "Day first contract signed",
        "daySignedContract": "Day first contract signed allowed counted leave",
        "update": "Update Leave Setting",
        "status": "Status",
        "allLeaveFirstMonth": "Full license issued in the first month",
        "allLeaveFirstMonthDetails": "For example: the number of leaves in a year for an employee is 15 days, then the first month of the cycle is 15 days.",
        "reasonLeave": "Reason for leave applies",
        "reasonLeaveDetails1": "The leave rule will apply to the default leave reason marked PN (in this case leave blank).",
        "reasonLeaveDetails2": "However, each business will have different regulations (Choose multiple reasons)",
        "chooseReasonLeave": "Select the reason for leave to apply",
        "isAccumulationMonthly": "Allow monthly leave accumulation",
        "isAccumulationMonthlyDetail": "Option to allow the accumulation of unused leave days from the previous month to the next month",
    },
    "messageLeaveSetting": {
        "delete": "Delete Successfully!",
        "add": "Add Successfully!",
        "update": "Update Successfully!",
        "accumulate" : "The remaining leave from the previous month will be carried over to the next month",
        "deplete" : "Remaining leave from the previous month will not be carried over to the next month",
        "annualLeaveAccumulation": "All annual leave (or leave corresponding to the remaining months) will be added in the first month of application.",
        "oldEmployeeLeaveGrant": "Old employees: Receive 12 leave days per year. At the beginning of the new year, the system will automatically grant 12 leave days.",
        "newEmployeeLeaveGrant": "New employees: Leave entitlement starts from July. For the last 6 months of the year, they will receive 6 leave days, which will be granted in July.",
        "recalculateLeaveMidMonth": "In mid-May, if the company creates a new leave type with this option, the system will recalculate the remaining leave for each employee and grant it at the beginning of that month.",
        "example" : "Example"




    },
    "leaveSetting": {
        "day": "day",
        "year": "year",
        "days": "days",
        "cu": "",
        "yearSeniorities": "years of seniority for every",
        "yearSeniority": "year of seniority for every",
        "seniorityLeave": "leave",
        "seniorityLeaves": "leaves",
        "inYear": "In year",
        "nextYear": "Next year",
        "cancel": "Cancel",
        "add": "Add",
        "update": "Update",
        "approved": "Enable",
        "disable": "Disable",
        "enable": "Enable",
    },
    "dayStartContractType": {
        "contractFirst": "Date of the first contract is allowed",
        "dayEntryOfPersonel": "Date of entry of personnel",
        "officialEntryDate": "Official entry date of personnel",
        "contract1Year": "Date of 1 year contract",
        "contractProbation": "Date of probation contract",
        "apprenticeshipContract": "Date of the apprenticeship contract",
        "indefiniteContract": "Date of indefinite contract",
        "dayOf": "Day of"
    },
    "placeholderLS": {
        "all": "All departments",
        "day": "Day",
        "month": "Month"
    },
    "btnTrans": {
        "cancel": "Cancel",
        "ok": "Confirm"
    }
}